import { objectKeysToCamelCase } from '../core-bundle/helpers/object-keys-camel-case';

import LaunchDarkly from '@app/modules/launchdarkly';

import Helper from '@app/helper';
import { FF_SIGNUP_VERIFICATION } from '@app/constant/experiments';

const makeUser = (response) => {
  const {
    id,
    full_name,
    email,
    language,
    transfer_default_expiry,
    plan_tier,
    rules,
    default_recipient_email,
    receiving_email_confirmed,
    is_verified,
    has_skipped_verification,
    onboarded,
    otp_enabled,
    otp_enabled_at,
    hide_profile_email,
  } = response;
  const user = {
    id,
    full_name,
    email,
    language,
    loggedIn: id,
    preferences: {
      transfer_default_expiry,
      onboarded,
    },
    defaults: {
      profile_picture_thumbnail_url: Helper.getAvatar(id),
    },
    planTier: plan_tier,
    rules: objectKeysToCamelCase(rules),
    default_recipient_email: default_recipient_email || '',
    receiving_email_confirmed: !!receiving_email_confirmed,
    hasSkippedVerification: has_skipped_verification,
    isVerified: LaunchDarkly.getVariant(FF_SIGNUP_VERIFICATION)
      ? is_verified
      : true,
    otpEnabled: otp_enabled,
    otpEnabledAt: otp_enabled_at,
    hideProfileEmail: hide_profile_email,
  };

  if (response.memberships && response.memberships[0]) {
    user.memberships = response.memberships;
    user.storageFull = !!response.memberships[0].storage_full;
  }

  user.profile_picture = response.profile_picture || null;

  return user;
};

export default {
  /*
    This method parses the response from either sign_in endpoint
    or the value of bootstrapped window.__session__.user
  */
  auth(response) {
    let account = {};
    let subscription = {};

    const { memberships } = response;

    // Retrieve account from memberships & subscription id
    if (memberships && memberships.length > 0 && memberships[0].account) {
      account = memberships[0].account;
      subscription = account.subscription;
    }

    return {
      user: makeUser(response),
      subscription,
      account,
    };
  },

  /*
    This method parses the response of user endpoint
  */
  user: makeUser,

  account(response) {
    let emailBackground = null;
    // Email background?
    if (response.email_background) {
      emailBackground = response.email_background;
    }

    return {
      ...response,
      email_background: emailBackground,
    };
  },
};
